import XIcon from "assets/icon/XIcon"

export default function BackButton(props){
    return(
        <button className="button flex gap-2 items-center text-xs" onClick={props?.onClick}>
            <XIcon className="w-5 fill-white" />
            <span>Back</span>
        </button>
    )
}